(ns app.front.ui.typography)


(defn h1
  ([title]
   [h1 "" title])
  ([class & title]
   (into [:h1.text-lg.leading-tight.font-bold {:class class}]
         title)))


(defn h2
  ([title]
   [h2 "" title])
  ([class & title]
   (into [:h2.text-base.leading-tight.font-bold {:class class}]
         title)))


(defn h3
  ([title]
   [h3 "" title])
  ([class & title]
   (into [:h3.text-sm.leading-tight {:class class}]
         title)))


(defn p
  ([body]
   [p "" body])
  ([class & body]
   (into [:p.p-0.leading-tight {:class class}]
         body)))
